module.exports = __webpack_public_path__ + "62bf0aac5b621ccee70768f3bd64b110.png";